import { render } from "./AutosaveBar.vue?vue&type=template&id=15149dc4&scoped=true"
import script from "./AutosaveBar.vue?vue&type=script&lang=js"
export * from "./AutosaveBar.vue?vue&type=script&lang=js"

import "./AutosaveBar.vue?vue&type=style&index=0&id=15149dc4&scoped=true&lang=scss"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15149dc4"]])

export default __exports__